import { useState, useEffect } from 'react';
import { auth } from '../../firebase';
import { useDispatch } from 'react-redux';
import { setRole } from '../../redux/slices/currentUserSlice';

export const useVenueRole = (venueId) => {
  const [localRole, setLocalRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    // Check for dev override first
    const overrideRole = localStorage.getItem('devRoleOverride');
    if (overrideRole) {
      setLocalRole(overrideRole);
      dispatch(setRole(overrideRole));
      setIsLoading(false);
      return; // Skip real auth logic
    }

    const unsubscribe = auth.onIdTokenChanged(async (user) => {
      if (user) {
        const token = await user.getIdTokenResult();
        const newRole = token.claims[venueId]?.role || null;
        setLocalRole(newRole);
        dispatch(setRole(newRole));
      } else {
        setLocalRole(null);
        dispatch(setRole(null));
      }
      setIsLoading(false);
    });

    // Cleanup the listener on component unmount
    return () => unsubscribe();
  }, [venueId, dispatch]);

  return { role: localRole, loading: isLoading };
};
